import React, { useState } from 'react';
import { useField } from 'formik';
import { Input, StyledInlineErrorMessage, IconContainer, Spinner} from '../../../styles';
import Api from '../../../Api/Api';

const ServerValidatedField = props => {
    const [field, meta, helpers] = useField(props);
    const [t, setT] = useState(null);
    const [apiError, setApiError] = useState(null);
    const [isValidating, setisValidating] = useState(null);
    const api = new Api();
    const handleValidation = async value => {
      if(field.value !== value){
        await handleAPIValidation(value).then(data => {
          if(!data.isValid){
            setApiError(data.validationMessage);
            setisValidating(false);
          } else {
            setApiError(null);
            setisValidating(false);
          }
        }).catch(error => {
          setisValidating(false);
          throw new Error('Something went wrong when validating field: ' + field.name)
        })
      }
    }

    async function handleAPIValidation (value) {
      return new Promise((resolve, reject) => {
        if (t) clearTimeout(t);
        setT(setTimeout(() => {
          setisValidating(true);
          if (field.name === "storename") {
          api.checkStoreNameApiValidation(value).then(data => {
            resolve(data);
          }).catch((message) => reject(message))
        } else {
          api.checkEmailApiValidation(value).then(data => {
            resolve(data);
          }).catch((message) => reject(message))
        }
      }, 750));
      });
    }
    
    return (
      <>
        <Input
          {...field} {...props}
          validate={handleValidation}
          error={meta.touched && meta.error || apiError}
        />
        {isValidating ? <IconContainer><Spinner>.</Spinner></IconContainer> : null}
        {apiError && meta.touched ?
          <StyledInlineErrorMessage>
            {apiError}
          </StyledInlineErrorMessage> : null
        }
      </>
    );
}

export default ServerValidatedField;